import { render, staticRenderFns } from "./StudentView.vue?vue&type=template&id=6ccc678a&scoped=true&"
import script from "./StudentView.vue?vue&type=script&lang=js&"
export * from "./StudentView.vue?vue&type=script&lang=js&"
import style0 from "./StudentView.vue?vue&type=style&index=0&id=6ccc678a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ccc678a",
  null
  
)

export default component.exports